import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _commonAddress = { geocode: '_commonAddressLocation' };
var _commonAddressLocation = {
    latitude: 'google.protobuf.DoubleValue',
    longitude: 'google.protobuf.DoubleValue',
};
var _deliverableItem = { physicalProperties: '_physicalProperties' };
var _deliveryLogistics = {
    pickupDetails: '_pickupDetails',
    deliveryTimeSlot: '_deliveryTimeSlot',
};
var _deliverySolution = { logistics: '_deliveryLogistics' };
var _deliveryTimeSlot = {
    from: 'google.protobuf.Timestamp',
    to: 'google.protobuf.Timestamp',
};
var _getDeliverySolutionsRequest = {
    lineItems: '_deliverableItem',
    destination: '_commonAddress',
    origin: '_commonAddress',
};
var _getDeliverySolutionsResponse = {
    deliverySolutions: '_deliverySolution',
};
var _physicalProperties = { weight: 'google.protobuf.DoubleValue' };
var _pickupDetails = { address: '_commonAddress' };
function resolveWixEcomDeliveryprofileV1DeliveryRatesUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/delivery-rates',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/delivery-rates',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Get Delivery Solutions for the given line items from all relevant delivery carriers */
export function getDeliverySolutions(payload) {
    var _a = serializer(_getDeliverySolutionsRequest, {
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _deliverableItem: _deliverableItem,
        _physicalProperties: _physicalProperties,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDeliverySolutionsResponse, {
        _commonAddress: _commonAddress,
        _commonAddressLocation: _commonAddressLocation,
        _deliveryLogistics: _deliveryLogistics,
        _deliverySolution: _deliverySolution,
        _deliveryTimeSlot: _deliveryTimeSlot,
        _pickupDetails: _pickupDetails,
    }).fromJSON;
    function __getDeliverySolutions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.gateways.ecom.v1.delivery_rates_gateway',
            method: 'POST',
            methodFqn: 'wix.ecom.deliveryprofile.v1.DeliveryRates.GetDeliverySolutions',
            url: resolveWixEcomDeliveryprofileV1DeliveryRatesUrl({
                protoPath: '/v1/get-delivery-solutions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDeliverySolutions.fromReq = fromReq;
    __getDeliverySolutions.__isAmbassador = true;
    return __getDeliverySolutions;
}
//# sourceMappingURL=http.impl.js.map